import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=27875a6b&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27875a6b')) {
      api.createRecord('27875a6b', component.options)
    } else {
      api.reload('27875a6b', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=27875a6b&", function () {
      api.rerender('27875a6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28Se2gCaGzT4S/JS/imageCarousel.vue"
export default component.exports